import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import { BaseActivity, BaseActivityText } from '@/components/activities/BaseActivity/BaseActivity';
import IconCheck from '@/icons/Check.svg';

export const RequestCompletedActivity = ({
  activity,
}: {
  activity: ActivityOfType<'request_completed'>;
}) => {
  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="primary"
      icon={<IconCheck />}
      message={
        <BaseActivityText>
          <Trans id="activities.request_completed.message">
            The request has been completed and archived
          </Trans>
        </BaseActivityText>
      }
    />
  );
};
